/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Urlpath1Inputs */

const en_entity_urlpath1 = /** @type {(inputs: Entity_Urlpath1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Path`)
};

const de_entity_urlpath1 = /** @type {(inputs: Entity_Urlpath1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-Pfad`)
};

/**
* | output |
* | --- |
* | "URL Path" |
*
* @param {Entity_Urlpath1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_urlpath1 = /** @type {((inputs?: Entity_Urlpath1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Urlpath1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_urlpath1(inputs)
	return de_entity_urlpath1(inputs)
});
export { entity_urlpath1 as "entity_urlPath" }